import walidacjaRaty from '@components/form/validation/field/rata'
import validated from '@components/form/validation/validated'

export default validated({
    t: 'Rata',
    name: 'rata',
    type: 'number',

}, walidacjaRaty)